import { Skeleton } from '../Skeleton';

export const CheckboxSkeleton = () => {
	return <Skeleton width={20} height={20} borderRadius={'4px'} />;
};
